import React from 'react';
import CollectionRow from './CollectionRow';

const CollectionsTableRows = ({
  category,
  className,
  items,
  onCheckBoxClick,
  columns,
}) => (
  items.map((item, index) => (
    <CollectionRow
      className={className}
      key={`collections_table_row_${item.code}`}
      category={category}
      collection={item}
      onCheckBoxClick={onCheckBoxClick}
      upward={index > 4}
      columns={columns}
    />
  ))
);

export default CollectionsTableRows;
